import { BASE_HANDLER_URL } from ".";
import { DEFAULT_GRID_INFO_USER } from "../Components/User/KendoUserGrid";

export const loadAllUserGridData = async (userFilter, gridState) => {
  document.getElementById("loader").style.display = "block";
  const {currentPage} = userFilter;
  const currentSize = gridState.pageSize ?? DEFAULT_GRID_INFO_USER.pageSize;
  const currentSortName =
    gridState.sort[0].field ?? DEFAULT_GRID_INFO_USER.sortName;
  const currentSortOrder =
    gridState.sort[0].dir ?? DEFAULT_GRID_INFO_USER.sortOrder;

  try {
    const formData = new FormData();
    formData.append("page", currentPage);
    formData.append("rp", currentSize);
    formData.append("sortname", currentSortName);
    formData.append("sortorder", currentSortOrder);
    formData.append("query", "");
    formData.append("qtype", "");

    const queryParams = new URLSearchParams({
      FName: userFilter.firstName,
      LName: userFilter.lastName,
      Email: userFilter.email,
      Type: userFilter.type,
      Active: userFilter.active,
      AccountActivated: userFilter.accountActivated,
    }).toString();

    const url = `${BASE_HANDLER_URL}?class=${
      DEFAULT_GRID_INFO_USER.className
    }&action=${DEFAULT_GRID_INFO_USER.action}&${
      queryParams ? `${queryParams}` : ""
    }`;
    const result = await fetch(url, {
      method: "POST",
      body: formData,
    });
    const response = await result.json();
    if (response?.status === true) {
      document.getElementById("loader").style.display = "none";
      return response;
    } 
      // LoadData();
    
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  document.getElementById("loader").style.display = "none";
};
